import { useParams } from "react-router-dom";

import { PostShiftForm } from "@/features/shifts/ui/PostShiftForm";
import { useShift } from "@/features/shifts/model/useShifts";
import { BackLink } from "@/shared/ui";

export function EditShiftPage() {
  const { id } = useParams<{ id: string }>();
  const { data: shift, isLoading, error } = useShift(id);
  const backTo = id ? `/venue/shifts/${id}` : "/venue";

  if (isLoading) {
    return (
      <div className="space-y-4">
        <BackLink to={backTo} label="Back to shift" />
        <div className="text-sm text-muted-foreground">Loading...</div>
      </div>
    );
  }
  if (error || !shift) {
    return (
      <div className="space-y-4">
        <BackLink to={backTo} label="Back to shift" />
        <div className="text-sm text-destructive">Shift not found.</div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <BackLink to={backTo} label="Back to shift" />
      <section className="rounded-lg border bg-card p-6 shadow-sm">
        <h2 className="mb-4 text-lg font-semibold">Edit shift</h2>
        <PostShiftForm existing={shift} />
      </section>
    </div>
  );
}
